export default __webpack_public_path__ + "static/media/project-preview.bc52fc8f.png";